export default __webpack_public_path__ + "static/media/earthling_5.2b859724.png";